export default {
  build_time: '2018-02-23T05:32:49+00:00',
  git_sha: '',
  git_tag: 'local',
};
